import { ROUTER, PAGE_VIEW_TYPES } from "../common/constants";
import ModuleType from "../common/module-constant";
import AIImageWebview from "../components/preview-image/webview/AIImageWebview.vue";
import DocumentAIWebview from "../components/document-ai/webview/DocumentAIWebview.vue";
// import TempComponent from '../containers/TempComponent.vue';

const PropertyContainer = () =>
    import("../containers/property/PropertyContainer.vue");
const PropertyView = () =>
    import(
        "../containers/property/property-detail-view/PropertyDetailComponent.vue"
    );
const ProjectView = () =>
    import(
        "../containers/property/project-detail-view/ProjectDetailComponent.vue"
    );
const PropertyEditPage = () =>
    import(
        "../containers/property/property-edit/views/property-edit-page/PropertyEditPageComponent.vue"
    );
const PropertyNewPage = () =>
    import(
        "../containers/property/property-edit/views/property-new-page/PropertyNewPageComponent.vue"
    );
const ProjectNewPage = () =>
    import(
        "../containers/property/property-edit/views/project-new-page/ProjectNewPageComponent.vue"
    );
const ProjectEditPage = () =>
    import(
        "../containers/property/property-edit/views/project-edit-page/ProjectEditPageComponent.vue"
    );

const PersonContainer = () =>
    import("../containers/person/PersonContainer.vue");
const PersonView = () =>
    import("../containers/person/person-detail/PersonDetailComponent.vue");
const PersonEditPage = () => 
    import(
        "../containers/person/person-forms/views/person-edit-page/PersonEditPageComponent.vue"
    );
const PersonNewPage = () =>
    import(
        "../containers/person/person-forms/views/person-new-page/PersonNewPageComponent.vue"
    );
const CompanyNewPage = () =>
    import(
        "../containers/person/company-forms/views/company-new-page/CompanyNewPageComponent.vue"
    );
const CompanyEditPage = () =>
    import(
        "../containers/person/company-forms/views/company-edit-page/CompanyEditPageComponent.vue"
    );
const CompanyViewPage = () =>
    import("../containers/person/company-detail/CompanyDetailComponent.vue");

const DemandContainer = () =>
    import("../containers/demand/DemandContainer.vue");
const DemandViewPage = () =>
    import("../containers/demand/demand-detail/DemandDetailComponent.vue");
const DemandEditPage = () =>
    import(
        "../containers/demand/demand-forms/views/demand-edit-page/DemandEditPageComponent.vue"
    );
const DemandNewPage = () =>
    import(
        "../containers/demand/demand-forms/views/demand-new-page/DemandNewPageComponent.vue"
    );

const TaskContainer = () => import("../containers/task/TaskContainer.vue");
const TaskDetailComponent = () =>
    import("../containers/task/task-detail-view/TaskDetailComponent.vue");
const TaskEditPage = () =>
    import(
        "../containers/task/task-forms/views/task-edit-page/TaskEditPageComponent.vue"
    );
const TaskNewPage = () =>
    import(
        "../containers/task/task-forms/views/task-new-page/TaskNewPageComponent.vue"
    );

const AgendaContainer = () =>
    import("../containers/agenda/AgendaContainer.vue");
const EditAppointment = () =>
    import("../containers/agenda/appointment/edit/EditAppointment.vue");
const EditOccurrenceAppointment = () =>
    import(
        "../containers/agenda/appointment/edit/EditOccurrenceAppointment.vue"
    );
const EditSeriesAppointment = () =>
    import("../containers/agenda/appointment/edit/EditSeriesAppointment.vue");
const NewAppointmentComponent = () =>
    import("../containers/agenda/appointment/new/NewAppointmentComponent.vue");
const SuperAppointmentDetail = () =>
    import(
        "../containers/agenda/components/calendar-event/super-event-picker-item/AgendaSuperEventPickerTooltipComponent.vue"
    );
const AgendaConfirmationComponent = () =>
    import(
        "../containers/agenda/components/agenda-confirmation-component/view/web-view/AgendaConfirmationWebViewComponent.vue"
    );

const PortalUpdateInternet = () =>
    import(
        "../containers/portal/portal-update-internet/PortalUpdateInternetContainer.vue"
    );
const PortalMediaStatistic = () =>
    import(
        "../containers/portal/portal-media-statistic/PortalMediaStatisticContainer.vue"
    );

const MyAccountContainer = () =>
    import(
        "../containers/config/base-config-component/BaseConfigComponent.vue"
    );
const PersonalAgendaConfigurationContainer = () =>
    import(
        "../containers/config/base-config-component/BaseConfigComponent.vue"
    );
const AppConfiguartionContainer = () =>
    import(
        "../containers/config-app/base-config-app-component/BaseConfigAppComponent.vue"
    );

const AdvanceSearch = () =>
    import("../containers/advance-search/AdvanceSearchComponent.vue");
const LargeMailing = () =>
    import("../containers/report/large-mailing/LargeMailingModalComponent.vue");
const SocialMedia = () =>
    import(
        "../containers/property/components/social-sharing/SocialSharingComponent.vue"
    );
const SmsMessage = () =>
    import("../containers/report/send-sms/SendSMSComponent.vue");
const SingleSocialMedia = () =>
    import(
        "../containers/property/components/single-social-sharing/SingleSocialSharingComponent.vue"
    );

const BrochureContainer = () =>
    import(
        "../containers/property/property-detail-view/brochure-modal/BrochureModalComponent.vue"
    );
const ManagementContainer = () =>
    import("../containers/management/base-management-component/BaseManagementComponent.vue");

const ConfirmationModal = () =>
    import(
        "../containers/property/property-edit/property-form/components/confirmation-modal/web-view-wrapper/ConfirmationModalWrapperWebView.vue"
    );
const TranslationModal = () =>
    import(
        "../containers/property/components/translate-dialog/TranslateDialogComponent.vue"
    );
const SmoovedModal = () =>
    import(
        "../containers/property/components/smooved/web-view/SmoovedWrapperWebView.vue"
    );
const SignDocumentModal = () =>
    import(
        "../components/document/sign-document/web-view/SignDocumentWrapperWebView.vue"
    );
const AiDescriptionModalWrapperWebView = () =>
    import(
        "../containers/property/property-edit/property-form/components/generate-description-ai/web-view-wrapper/AiDescriptionModalWrapperWebView.vue"
    );
const AiTitleModalWrapperWebView = () =>
    import(
        "../containers/property/property-edit/property-form/components/generate-title-ai/web-view-wrapper/GenerateTitleAiWrapperWebView.vue"
    );
const VideoManagementWebView = () =>
    import(
        "../containers/config-app/components/video-management/web-view/VideoManagementWebView.vue"
    );
const VideoManagement = () =>
    import(
        "../containers/config-app/components/video-management/VideoManagementComponent.vue"
    );

const AboutView = () => import("../components/help/AboutComponent.vue");

const SendInvoice = () =>
    import(
        "../containers/property/property-edit/property-form/components/invoice/components/sendInvoice/SendInvoiceComponent.vue"
    );
// Note: do not set viewType for list view
const propertyRoutes = [
    {
        path: "/property",
        name: ROUTER.PROPERTY.PROPERTY,
        component: PropertyContainer,
        meta: {
            title_key: "PROPERTY",
            icon_name: "ico_home",
            persistent: false,
            moduleType: ModuleType.Object
        },
        props: {}
    },
    {
        path: "/property/view/:id",
        name: ROUTER.PROPERTY.PROPERTY_VIEW,
        component: PropertyView,
        meta: {
            keepAlive: true,
            icon_name: "ico_home",
            moduleType: ModuleType.Object,
            viewType: PAGE_VIEW_TYPES.DETAIL,
        }
    },
    {
        path: "/property/edit/:id",
        name: ROUTER.PROPERTY.PROPERTY_EDIT,
        component: PropertyEditPage,
        meta: {
            icon_name: "ico_home",
            moduleType: ModuleType.Object,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/property/new/:id",
        name: ROUTER.PROPERTY.PROPERTY_NEW,
        component: PropertyNewPage,
        meta: {
            icon_name: "ico_home",
            moduleType: ModuleType.Object,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    },
    {
        path: "/project/view/:id",
        name: ROUTER.PROPERTY.PROPERTY_PROJECT_VIEW,
        component: ProjectView,
        meta: {
            keepAlive: true,
            icon_name: "ico_project",
            moduleType: ModuleType.Project,
            viewType: PAGE_VIEW_TYPES.DETAIL
        }
    },
    {
        path: "/project/edit/:id",
        name: ROUTER.PROJECT.PROJECT_EDIT,
        component: ProjectEditPage,
        meta: {
            icon_name: "ico_project",
            moduleType: ModuleType.Project,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/project/new/:id",
        name: ROUTER.PROJECT.PROJECT_NEW,
        component: ProjectNewPage,
        meta: {
            icon_name: "ico_project",
            moduleType: ModuleType.Project,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    },
    {
        path: "/social-media/:moduleId/:propertyId/:projectId",
        name: ROUTER.PROPERTY.PROPERTY_SOCIAL_MEDIA,
        component: SocialMedia,
        meta: {
            icon_name: "ico_share"
        }
    },
    {
        path: "/brochure/:propertyId/:projectId",
        name: ROUTER.PROPERTY.PROPERTY_BROCHURE,
        component: BrochureContainer,
        meta: {
            icon_name: "ico_check"
        }
    },
    {
        path:
            "/single-social-media/:moduleId/:propertyId/:projectId/:focusType",
        name: ROUTER.PROPERTY.PROPERTY_SOCIAL_MEDIA,
        component: SingleSocialMedia,
        meta: {
            icon_name: "ico_share"
        },
        props: {
            isWebView: true
        }
    },
    {
        path:
            "/confirmation-modal/:propertyId/:isSmoovedNeeded(true)/:newStatus(SOLD|RENTED)/:salePrice/:PurposeId",
        name: ROUTER.PROPERTY.PROPERTY_CONFIRMATION_MODAL,
        component: ConfirmationModal,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "CONFIRMATION_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        },
        props: {}
    },
    {
        path:
            "/translate-modal/:isHasProperty(true|false)/:isHasProject(true|false)",
        name: ROUTER.PROPERTY.PROPERTY_TRANSLATE_MODAL,
        component: TranslationModal,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "TRANSLATE_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        },
        props: {}
    },
    {
        path: "/smooved-modal/:propertyId/:PurposeId",
        name: ROUTER.PROPERTY.PROPERTY_SMOOVED_MODAL,
        component: SmoovedModal,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "PROPERTY_SMOOVED_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        },
        props: {
            property: {}
        }
    },
    {
        path: "/document-signature",
        name: ROUTER.PROPERTY.PROPERTY_SMOOVED_MODAL,
        component: SignDocumentModal,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "DIGITAL_SIGNATURE",
            viewType: PAGE_VIEW_TYPES.EDIT
        },
        props: {
            property: {}
        }
    },
    {
        path:
            "/ai-description-modal/:propertyId/:descriptionId/:descriptionFieldName",
        name: ROUTER.PROPERTY.PROPERTY_AI_DESCRIPTION_MODAL,
        component: AiDescriptionModalWrapperWebView,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "AI_DESCRIPTION_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/streaming-ai-description-modal/property/:propertyId",
        name: ROUTER.PROPERTY.PROPERTY_AI_DESCRIPTION_MODAL,
        component: AiDescriptionModalWrapperWebView,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "AI_DESCRIPTION_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        },
        props: {
            type: 'property'
        }
    },
    {
        path: "/streaming-ai-description-modal/project/:projectId",
        name: ROUTER.PROPERTY.PROPERTY_AI_DESCRIPTION_MODAL,
        component: AiDescriptionModalWrapperWebView,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "AI_DESCRIPTION_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        },
        props: {
            type: 'project'
        }
    },
    {
        path: "/ai-title-modal/:propertyId",
        name: ROUTER.PROPERTY.PROPERTY_AI_DESCRIPTION_MODAL,
        component: AiTitleModalWrapperWebView,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "AI_TITLE_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/ai-title-modal",
        name: ROUTER.PROPERTY.PROPERTY_AI_DESCRIPTION_MODAL,
        component: AiTitleModalWrapperWebView,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "AI_TITLE_MODAL",
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/video-selection",
        name: ROUTER.PROPERTY.PROPERTY_VIDEO_MANAGEMENT_WEBVIEW,
        component: VideoManagementWebView,
        meta: {
            icon_name: "ico_share",
            moduleType: ModuleType.Object,
            persistent: false,
            standalone: true,
            title_key: "VIDEO_MANAGEMENT",
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/send-invoice/:propertyId",
        name: ROUTER.PROPERTY.PROPERTY_SEND_INVOICE,
        component: SendInvoice,
        meta: {
            icon_name: "ico_share",
        },
        props: {
            visible: true
        }
    }
];

const personRoutes = [
    {
        path: "/client",
        name: ROUTER.CLIENT.CLIENT,
        component: PersonContainer,
        meta: {
            title_key: "CLIENT",
            icon_name: "ico_person",
            persistent: false,
            moduleType: ModuleType.Person
        },
        props: {}
    },
    {
        path: "/client/view/:id",
        name: ROUTER.CLIENT.CLIENT_VIEW,
        component: PersonView,
        meta: {
            keepAlive: true,
            
            icon_name: "ico_person",
            moduleType: ModuleType.Person,
            viewType: PAGE_VIEW_TYPES.DETAIL
        }
    },
    {
        path: "/client/edit/:id",
        name: ROUTER.CLIENT.CLIENT_EDIT,
        component: PersonEditPage,
        meta: {
            icon_name: "ico_person",
            moduleType: ModuleType.Person,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/client/new/:id",
        name: ROUTER.CLIENT.CLIENT_NEW,
        component: PersonNewPage,
        meta: {
            icon_name: "ico_person",
            moduleType: ModuleType.Person,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    },
    {
        path: "/company/new/:id",
        name: ROUTER.COMPANY.NEW,
        component: CompanyNewPage,
        meta: {
            icon_name: "o_ico_companies",
            moduleType: ModuleType.Company,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    },
    {
        path: "/company/view/:id",
        name: ROUTER.COMPANY.VIEW,
        component: CompanyViewPage,
        meta: {
            keepAlive: true,
            icon_name: "o_ico_companies",
            moduleType: ModuleType.Company,
            viewType: PAGE_VIEW_TYPES.DETAIL
        }
    },
    {
        path: "/company/edit/:id",
        name: ROUTER.COMPANY.EDIT,
        component: CompanyEditPage,
        meta: {
            icon_name: "o_ico_companies",
            moduleType: ModuleType.Company,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    }
];
const demandRoutes = [
    {
        path: "/demand",
        name: ROUTER.DEMAND.DEMAND,
        component: DemandContainer,
        meta: {
            title_key: "DEMAND",
            icon_name: "ico_demand",
            persistent: false,
            moduleType: ModuleType.Demand
        },
        props: {}
    },
    {
        path: "/demand/view/:id",
        name: ROUTER.DEMAND.DEMAND_DETAIL,
        component: DemandViewPage,
        meta: {
            keepAlive: true,
            icon_name: "ico_demand",
            moduleType: ModuleType.Demand,
            viewType: PAGE_VIEW_TYPES.DETAIL
        }
    },
    {
        path: "/demand/edit/:id",
        name: ROUTER.DEMAND.DEMAND_EDIT,
        component: DemandEditPage,
        meta: {
            icon_name: "ico_demand",
            moduleType: ModuleType.Demand,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/demand/new/:id",
        name: ROUTER.DEMAND.DEMAND_NEW,
        component: DemandNewPage,
        meta: {
            icon_name: "ico_demand",
            moduleType: ModuleType.Demand,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    }
];
const taskRoutes = [
    {
        path: "/task",
        name: ROUTER.TASK.TASK,
        component: TaskContainer,
        meta: {
            title_key: "TASK",
            icon_name: "ico_task",
            persistent: false,
            moduleType: ModuleType.Task
        },
        props: {}
    },
    {
        path: "/task/view/:id",
        name: ROUTER.TASK.TASK_VIEW,
        component: TaskDetailComponent,
        meta: {
            keepAlive: true,
            icon_name: "ico_task",
            moduleType: ModuleType.Task,
            viewType: PAGE_VIEW_TYPES.DETAIL
        }
    },
    {
        path: "/task/edit/:id",
        name: ROUTER.TASK.TASK_EDIT,
        component: TaskEditPage,
        meta: {
            icon_name: "ico_task",
            moduleType: ModuleType.Task,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/task/new/:id",
        name: ROUTER.TASK.TASK_NEW,
        component: TaskNewPage,
        meta: {
            icon_name: "ico_task",
            moduleType: ModuleType.Task,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    }
];

const agendaRoutes = [
    {
        path: "/agenda",
        name: ROUTER.AGENDA.AGENDA,
        component: AgendaContainer,
        meta: {
            title_key: "AGENDA",
            icon_name: "ico_calendar",
            persistent: false,
            moduleType: ModuleType.Agenda
        },
        props: {}
    },
    {
        path: "/agenda/new/:id",
        name: ROUTER.AGENDA.AGENDA_NEW,
        component: NewAppointmentComponent,
        meta: {
            icon_name: "ico_calendar",
            moduleType: ModuleType.Agenda,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    },
    {
        path: "/agenda/edit/:id",
        name: ROUTER.AGENDA.AGENDA_EDIT,
        component: EditAppointment,
        meta: {
            icon_name: "ico_calendar",
            moduleType: ModuleType.Agenda,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/agenda/edit-series/:id", // id = masterId
        name: ROUTER.AGENDA.AGENDA_EDIT_SERIES,
        component: EditSeriesAppointment,
        meta: {
            icon_name: "ico_calendar",
            moduleType: ModuleType.Agenda,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/agenda/edit-occurrence/:id/:startDate", // id = masterId
        name: ROUTER.AGENDA.AGENDA_EDIT_OCCURRENCE,
        component: EditOccurrenceAppointment,
        meta: {
            icon_name: "ico_calendar",
            moduleType: ModuleType.Agenda,
            viewType: PAGE_VIEW_TYPES.EDIT
        }
    },
    {
        path: "/agenda/super-appointment-detail/:userId/:start/:propertyId",
        name: ROUTER.AGENDA.AGENDA_SUPERAPPOINTMENT_DETAIL,
        component: SuperAppointmentDetail,
        meta: {
            icon_name: "ico_calendar",
            moduleType: ModuleType.Agenda,
            viewType: PAGE_VIEW_TYPES.DETAIL
        }
    },
    {
        path: "/agenda/:agendaId/confirmation/:startTime",
        name: ROUTER.AGENDA.AGENDA_CONFIRMATION,
        component: AgendaConfirmationComponent,
        meta: {
            icon_name: "ico_check",
            moduleType: ModuleType.Agenda,
            viewType: PAGE_VIEW_TYPES.DETAIL,
            visible: true
        }
    }
];
const portalRoutes = [
    {
        path: "/portal/update-internet",
        name: ROUTER.PORTAL.PORTAL_UPDATE_INTERNET,
        component: PortalUpdateInternet,
        meta: {
            title_key: "UPDATE_INTERNET",
            icon_name: "ico_settings",
            persistent: false,
            standalone: true
        },
        props: {}
    },
    {
        path: "/portal/media-statistic",
        name: ROUTER.PORTAL.PORTAL_MEDIA_STATISTIC,
        component: PortalMediaStatistic,
        meta: {
            title_key: "MEDIA_STATISTIC",
            icon_name: "ico_chart",
            persistent: false,
            standalone: true
        },
        props: {}
    }
];

const configRoutes = [
    {
        path: "/agenda-configuration",
        name: ROUTER.AGENDA_CONFIGURATION,
        component: PersonalAgendaConfigurationContainer,
        meta: {
            title_key: "AGENDA_CONFIGURATION",
            icon_name: "ico_calendar-setting",
        }
    },
    {
        path: "/my-account",
        name: ROUTER.MY_ACCOUNT,
        component: MyAccountContainer,
        meta: {
            title_key: "MY_ACCOUNT",
            icon_name: "ico_person",
            persistent: false,
            standalone: true,
            moduleType: ModuleType.MyAccount
        },
        props: {}
    },
    {
        path: "/configuration",
        name: ROUTER.CONFIGURATION,
        component: AppConfiguartionContainer,
        meta: {
            title_key: "CONFIGURATION",
            icon_name: "ico_settings",
            persistent: false,
            standalone: true,
            moduleType: ModuleType.Configs
        },
        props: {}
    },
    {
        path: "/video-management",
        name: ROUTER.VIDEO_MANAGEMENT,
        component: VideoManagement,
        meta: {
            title_key: "VIDEO_MANAGEMENT",
            icon_name: "el-icon-video-play",
            persistent: false,
            standalone: true,
            moduleType: ModuleType.Configs
        },
        props: {}
    }
];

const advanceSearch = [
    {
        path: "/advance-search/:id",
        name: ROUTER.ADVANCE_SEARCH,
        component: AdvanceSearch,
        meta: {
            icon_name: "ico_search",
            moduleType: ModuleType.AdvanceSearch,
            viewType: PAGE_VIEW_TYPES.SEARCH,
            title_key: "Advance Search",
            standalone: true
        },
        props: {}
    }
];

const reportRoutes = [
    {
        path: "/large-mailing",
        name: ROUTER.REPORT.LARGE_MAILING,
        component: LargeMailing,
        meta: {
            icon_name: "ico_large-mailing",
            moduleType: ModuleType.NULL,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    },
    {
        path: "/sms-message",
        name: ROUTER.REPORT.SMS_MESSAGE,
        component: SmsMessage,
        meta: {
            icon_name: "ico_chatbubble",
            moduleType: ModuleType.NULL,
            viewType: PAGE_VIEW_TYPES.NEW
        }
    }
];

const managementRoutes = [
    {
        path: "/management",
        name: ROUTER.MANAGEMENT,
        component: ManagementContainer,
        meta: {
            title_key: "MANAGEMENT",
            icon_name: "ico_management",
            moduleType: ModuleType.Management,
            standalone: true,
            persistent: false
        }
    }
];

const helpRoutes = [
    {
        path: "/about",
        name: ROUTER.ABOUT,
        component: AboutView,
        meta: {
            icon_name: "ico_information",
            moduleType: ModuleType.NULL
        }
    }
];

const aiImageRoutes = [
    {
        path: "/ai-image",
        name: ROUTER.AI_IMAGE,
        component: AIImageWebview,
    }
];

const documentAIRoutes = [
    {
        path: "/document-ai",
        name: ROUTER.DOCUMENT_AI,
        component: DocumentAIWebview,
    }
];

const RequestOfPropertyDocuments = () =>
    import(
        "../components/request-of-property-documents/RequestOfPropertyDocuments.vue"
    );

const webPageRoutes = [
    {
        path: "/request-of-property-documents/:id",
        name: ROUTER.WEB_PAGE.REQUEST_OF_PROPERTY_DOCUMENTS,
        component: RequestOfPropertyDocuments,
        meta: {
            icon_name: "ico_information",
            moduleType: ModuleType.NULL
        }
    }
];

export default [
    ...aiImageRoutes,
    ...documentAIRoutes,
    ...propertyRoutes,
    ...personRoutes,
    ...demandRoutes,
    ...taskRoutes,
    ...agendaRoutes,
    ...portalRoutes,
    ...configRoutes,
    ...advanceSearch,
    ...reportRoutes,
    ...managementRoutes,
    ...helpRoutes,
    ...webPageRoutes
];
